import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "6bf3e6a1-ca66-4400-93d3-a8d9eeabe413",
  publicId: "29",
  name: "Matricial formalism for waveguides",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, task01],
};

export default lesson;
